import { apiSlice } from "features/api/apiSlice";
import { transformDoctor } from "./transformDoctor";

const getOnlineDoctors = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getOnlineDoctors: build.query({
      query: ({ filter, isPremium }) => { 
        const params = new URLSearchParams({
          ...(filter && { specializations: filter }),
          ...(isPremium && { joinSubscription: true }),
        });
        return `/doctors/mwell/oncall/list?${params}`;
      },
      transformResponse: (res) => {
        return res.d.map(transformDoctor);
      },
    }),
  }),
});

export const { useGetOnlineDoctorsQuery } = getOnlineDoctors;
